import { render, staticRenderFns } from "./CouponForm.vue?vue&type=template&id=fb8c3722&scoped=true&"
import script from "./CouponForm.vue?vue&type=script&lang=js&"
export * from "./CouponForm.vue?vue&type=script&lang=js&"
import style0 from "./CouponForm.vue?vue&type=style&index=0&id=fb8c3722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8c3722",
  null
  
)

export default component.exports